var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanadd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1000005592-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #021472;stroke-linecap: round;stroke-linejoin: round;stroke-width: .6 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m7.6 3.7v-2.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m8.9 2.4l-2.6-0.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1.4 5.3l2.9-1c0.3-0.1 0.7 0 0.9 0.2l1.1 0.6q0.3 0.2 0.4 0.6 0.1 0.4-0.1 0.7-0.1 0.3-0.4 0.5h-0.1l-0.2 0.1q-0.2 0-0.4-0.2l-1-0.6m1.6 0.7q-0.1 0-0.2 0.1l-2.7 0.7q0.1 0 0.3 0.1l1.9 1.2q0.2 0.2 0.5 0.2 0.4 0 0.6-0.1l2.8-1.6q0.2-0.2 0.4-0.5 0.1-0.4 0-0.7-0.2-0.3-0.4-0.5-0.3-0.1-0.6 0l-2.5 1.1q-0.1 0-0.1 0zm-2.9 0.8q-0.2 0-0.4 0l-0.8 0.3 1.2-0.3q0 0 0 0zm-2-3l1 4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanadd);
export default __webpack_public_path__ + "static/media/loanadd.576c08ae652dcdeace376dbd0d67c852.svg";
export { ForwardRef as ReactComponent };